import { type PlatformEvent } from '../types';

export const makeGameLoadEndEvent = (gameKey: string): PlatformEvent => {
  return {
    type: 'game_load_end',
    user_properties: {},
    event_properties: {
      game_key: gameKey,
      name: 'game_load_end',
    },
  };
};
